/*
 * @Author: your name
 * @Date: 2021-09-26 21:29:54
 * @LastEditTime: 2021-12-24 15:40:02
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%A E
 * @FilePath: \h5-vip\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant'
import "vant/lib/index.css"
import router from './router'
const tui = require('./utils/uni.webview.js')
Vue.prototype.$uni = tui

// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// Vue.use(vConsole)

import store from './store/index';

import { setCookie, getCookie } from "./utils/cookie"

import VueClipboard from 'vue-clipboard2' //引入插件
Vue.use(VueClipboard)


// import axios from 'axios'
// Vue.prototype.$http = axios
Vue.prototype.getCookie = getCookie
Vue.prototype.setCookie = setCookie
Vue.config.productionTip = false
Vue.use(Vant)

// Vue.use(VueAMap);
// VueAMap.initAMapApiLoader({
//     key: 'c4de786c74a450ac841ea096528c6ff1',
//     plugin: ['AMap.Autocomplete', 'AMap.Geocoder', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.AMapManager', 'AMap.Geolocation'],
//     v: '1.4.4',
//     uiVersion: '1.0.11'
// });


new Vue({
    router,
    store,

    render: h => h(App),
}).$mount('#app')